import * as React from 'react';
import { ReportFieldDefinition } from "../../../../models";
import Typography from '../../../Typography';
import { TextInputField } from '../../fields';

interface MultiLineTextFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    style?: React.CSSProperties,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const MultiLineTextField: React.FC<MultiLineTextFieldProps> = ({
    id,
    value,
    style,
    invalid,
    readOnly,
    onChange,
}) => {
    return readOnly 
        ? <Typography id={id} style={style}>{value}</Typography>
        : <TextInputField id={id} style={style} inputStyle={{height: style?.height}} type="textarea" invalid={invalid} value={value} onChange={onChange} disabled={readOnly}/>
}